export default "__VITE_ASSET__ym5HhsoY__"